import { render } from "./DataVisualizationView.vue?vue&type=template&id=4d7bdac9&scoped=true"
import script from "./DataVisualizationView.vue?vue&type=script&lang=js"
export * from "./DataVisualizationView.vue?vue&type=script&lang=js"

import "./DataVisualizationView.vue?vue&type=style&index=0&id=4d7bdac9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7bdac9"]])

export default __exports__